import styled from 'styled-components'
import { HeadingsContainer } from '@components/ProductsSlider/ProductsSlider.styles'
import type { ComplementaryProductsProps } from './ComplementaryProducts.types'

export const Container = styled.div<{
  layout: ComplementaryProductsProps['layout']
}>`
  max-width: var(--container-max-width);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 0;

  @media screen and (min-width: 992px) {
    height: 100%;
    gap: ${({ layout }) => (layout === 'ultra-condensed' ? '2rem' : '3rem')};
    padding: ${({ layout }) =>
      layout === 'ultra-condensed' ? '0 1rem' : '0 1.5rem'};

    .product-slider {
      margin-top: 0;
      padding: 0;

      ${HeadingsContainer} {
        padding: 0;
      }

      .swiper {
        padding: 0;
      }
    }
  }
`

export const Title = styled.h2`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.serif.fontFamily};
  letter-spacing: -0.1rem;

  @media screen and (min-width: 768px) {
    font-size: 3rem;
  }
`

export const Content = styled.div<{
  layout: ComplementaryProductsProps['layout']
}>`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media screen and (min-width: 992px) {
    height: 100%;
    gap: ${({ layout }) => (layout === 'ultra-condensed' ? '1rem' : '1.5rem')};
    display: grid;
    grid-template-columns:
      minmax(
        auto,
        ${({ layout }) =>
          layout === 'condensed' || layout === 'ultra-condensed'
            ? '43.5%'
            : '45%'}
      )
      auto;
    align-items: stretch;
  }
`

export const ImageContainer = styled.div`
  width: 100%;
  max-height: 80vh;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
